import { LayersDataProtectionContent, Languages, Locale, RGPDContent } from "src/model/shop.model";

export interface MarketState {
  marketId: number;
  lang: string;
  langId: number;
  languages?: Languages;
  locale?: Locale;
  expeditionDivision: boolean;
  rgpd?: RGPDContent;
  layersDataProtection?: LayersDataProtectionContent;
  apiHost?: string;
  isMarketTaxes?: boolean;
}

export const marketInitialState: MarketState = {
  marketId: null,
  lang: "",
  langId: 0,
  languages: null,
  locale: null,
  expeditionDivision: false,
  rgpd: {
    isEnabled: false,
    showPopup: false,
  },
  layersDataProtection: {
    dataController: "",
    purposesAndLegalBases: "",
    recipients: "",
    rights: "",
    additionalInformation: "",
  },
  apiHost: "",
  isMarketTaxes: false,
};
